import React from 'react'

const VideoElement = ( props ) => {
  const { styles, src } = props.item.content
  
  return (
    <div
      style={{
        ...styles,
        backgroundImage: `url(${src.image || 'https://i.vimeocdn.com/video/846217893_295x166.webp'})`,
        backgroundSize: '100% 100%'
      }} 
    />
  )
}


export default VideoElement


// WEBPACK FOOTER //
// ./src/components/commons/editor/VideoElement.js